import { useParams } from "react-router-dom";
import Communications from "../../components/Communication/Communications";

export default function BuyerCommunications() {
  const { id } = useParams();

  return (
    <Communications id={id} userRole={"Buyer"} />
  );
}